import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { ManageLongDistanceTimeBandsComponent } from './manage-long-distance-time-bands.component';

const routes: Routes = [
  {
    path: '',
    component: ManageLongDistanceTimeBandsComponent,
    data: { title: 'Manage long-distance time-bands' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManageLongDistanceTimeBandsRoutingModule {}

@NgModule({
  imports: [
    ManageLongDistanceTimeBandsRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [ManageLongDistanceTimeBandsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ManageLongDistanceTimeBandsModule {}
